import { render, staticRenderFns } from "./narrative-statements-table.vue?vue&type=template&id=39252d7e"
import script from "./narrative-statements-table.vue?vue&type=script&lang=js"
export * from "./narrative-statements-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports